/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, TextField, MenuItem,
  Select, Button, Typography, Divider, Stack, FormControl, InputLabel,
  IconButton, Radio, RadioGroup, FormControlLabel, CircularProgress,
  Alert,
  Snackbar
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { Header } from 'components/home';
import { ContainerForm } from 'components/shared/container_form';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { CicaafAPI } from 'api/cicaaf/cicaaf.api';
import TextFieldDataCustom from 'components/shared/textfiel_data_custom';
import { ROUTES } from 'routes/constants';

interface IProduct {
  product_uuid: string;
  product_type: string;
  product_name: string;
}

interface IProductionData {
  products: Array<{
    product_uuid: string;
    product_type: string;
    product_name: string;
    commercialized_volume: number;
    commercialized_value: number;
    measurement_unit: string;
  }>;
  vegetal_license: {
    has_sanitary_license: boolean;
    license_number?: string;
    issuing_agency?: string;
    issue_date?: string;
  };
  animal_inspection: {
    has_inspection_register: boolean;
    inspection_seals?: Array<{
      register_number: string;
      inspection_seal: string;
      issue_date: string;
    }>;
  };
}
interface IProdutoForm {
  product_uuid: string;
  product_name: string;
  product_type: string;
  commercialized_volume: number;
  commercialized_value: number;
  measurement_unit: string;
  has_sanitary_license: boolean;
  vegetal_license?: {
    issuing_agency: string;
    license_number: string;
    issue_date: string;
  };
  has_inspection_register: boolean;
  inspection_seals: Array<{
    inspection_seal: string;
    register_number: string;
    issue_date: string;
  }>;
  showSeloForm: boolean;
}

export enum EUnidadeMedida {
  KG = "KG",
  TON = "TON",
  L = "L",
  UN = "UN",
  CX = "CX",
  SC = "SC"
}


export enum CicaafSanitaryAgencyEnum {
  MUNICIPAL_HEALTH_SECRETARIAT = 'SECRETARIA SAÚDE MUNICÍPIO',
  STATE_HEALTH_SECRETARIAT = 'SECRETARIA SAÚDE ESTADO',
}

export enum ESeloInspecao {
  SIM = "Serviço de Inspeção Municipal – SIM",
  SIF = "Serviço de Inspeção Federal – SIF",
  SISE = "Serviço de Inspeção Estadual – SISE",
  SISBI = "Sistema Brasileiro de Inspeção de Produtos de Origem Animal – SISBI",
  SUSAF_MT = "Sistema Estadual Unificado de Sanidade Agroindustrial Familiar – SUSAF MT",
  SIAPP = "Serviço de Inspeção Agroindustrial de Pequeno Porte – SIAPP"
}
const UNIDADES_MEDIDA = Object.entries(EUnidadeMedida).map(([value, label]) => ({ label, value }));

const ORGAOS_EMISSORES = [
  { value: CicaafSanitaryAgencyEnum.MUNICIPAL_HEALTH_SECRETARIAT, label: 'SECRETARIA SAÚDE MUNICÍPIO' },
  { value: CicaafSanitaryAgencyEnum.STATE_HEALTH_SECRETARIAT, label: 'SECRETARIA SAÚDE ESTADO' }
];


const TIPOS_SELO = Object.values(ESeloInspecao);

export const formatCurrency = (value: number) => {
  return (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const buildPayload = (formDataParam: IProdutoForm[]) => {
  const vegetalData = formDataParam.find(p => p.has_sanitary_license && p.vegetal_license);

  const payload = {
    products: formDataParam.map(prod => ({
      measurement_unit: prod.measurement_unit,
      product_uuid: prod.product_uuid,
      commercialized_value: parseFloat(prod.commercialized_value.toString()),
      commercialized_volume: Number(prod.commercialized_volume),
    })),
    vegetal_license: {
      has_sanitary_license: formDataParam.some(p => p.has_sanitary_license),
      issuing_agency: vegetalData?.vegetal_license?.issuing_agency ?? undefined,
      license_number: vegetalData?.vegetal_license?.license_number ?? undefined,
      issue_date: vegetalData?.vegetal_license?.issue_date ?? undefined,
    },
    animal_inspection: {
      has_inspection_register: formDataParam.some(p => p.has_inspection_register),
      inspection_seals: formDataParam.flatMap(p => p.inspection_seals || [])
    }
  };
  return payload;
};

export const validateFormData = (formDataParam: IProdutoForm[]) => {
  for (const produto of formDataParam) {
    if (produto.commercialized_value < 0 || isNaN(produto.commercialized_value)) {
      return { valid: false, message: 'Valor comercializado deve ser maior ou igual a zero.' };
    }
    if (produto.measurement_unit !== 'KG') {
      return { valid: false, message: `Produto "${produto.product_name}" deve ter unidade de medida "KG".` };
    }
  }
  return { valid: true };
};

export const addProductToForm = (formDataParam: IProdutoForm[], availableProductsParam: IProduct[], selectedProductParam: string) => {
  if (!selectedProductParam) return { formData: formDataParam, selectedProduct: '' };
  const product = availableProductsParam.find(p => p.product_uuid === selectedProductParam);
  if (product && !formDataParam.some(p => p.product_uuid === selectedProductParam)) {
    const novo = {
      product_type: product.product_type,
      product_uuid: product.product_uuid,
      product_name: product.product_name,
      commercialized_value: 0,
      has_inspection_register: false,
      commercialized_volume: 0,
      measurement_unit: 'KG',
      has_sanitary_license: false,
      inspection_seals: [],
      showSeloForm: false
    } as unknown as IProdutoForm;
    return { formData: [...formDataParam, novo], selectedProduct: '' };
  }
  return { formData: formDataParam, selectedProduct: '' };
};

export const removeProductAt = (formDataParam: IProdutoForm[], index: number) => {
  return formDataParam.filter((_, i) => i !== index);
};

export const updateProductField = (formDataParam: IProdutoForm[], index: number, field: keyof IProdutoForm, value: any) => {
  const novos = [...formDataParam];
  (novos[index] as any)[field] = value;
  return novos;
};

export const updateLicenseVegetal = (formDataParam: IProdutoForm[], produtoIndex: number, campo: keyof NonNullable<IProdutoForm['vegetal_license']>, valor: string) => {
  const novosProdutos = [...formDataParam];
  const produto = novosProdutos[produtoIndex];
  if (!produto.vegetal_license) {
    produto.vegetal_license = { license_number: '', issuing_agency: '', issue_date: '' } as any;
  }
  produto.vegetal_license![campo] = valor;
  return novosProdutos;
};

export const parseCurrencyInput = (value: string) => {
  const numericValue = value.replace(/\D/g, '');
  return Number(numericValue);
};

export const addSealToProduct = (formDataParam: IProdutoForm[], produtoIndex: number, novoSeloParam: { inspection_seal: string; register_number: string; issue_date: string }) => {
  if (!novoSeloParam.inspection_seal || !novoSeloParam.register_number || !novoSeloParam.issue_date) return formDataParam;
  const novos = [...formDataParam];
  novos[produtoIndex].showSeloForm = false;
  novos[produtoIndex].inspection_seals.push({ ...novoSeloParam });
  return novos;
};

export const toggleSeloFormInForm = (formDataParam: IProdutoForm[], produtoIndex: number) => {
  const novos = [...formDataParam];
  novos[produtoIndex].showSeloForm = !novos[produtoIndex].showSeloForm;
  return novos;
};

export const removeSealFromProduct = (formDataParam: IProdutoForm[], produtoIndex: number, seloIndex: number) => {
  const novos = [...formDataParam];
  novos[produtoIndex].inspection_seals.splice(seloIndex, 1);
  return novos;
};

export const ProdutosProcessadosCicaaf: React.FC = () => {
  const { uuid: collectionUuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const [availableProducts, setAvailableProducts] = useState<IProduct[]>([]);
  const [formData, setFormData] = useState<IProdutoForm[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string>('');
  const [novoSelo, setNovoSelo] = useState({
    register_number: '',
    inspection_seal: '',
    issue_date: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'warning' | 'info'>('info');
  const [alertMessage, setAlertMessage] = useState('');

  const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };


  useEffect(() => {
    const loadInitialData = async () => {
      if (!collectionUuid) {
        setLoading(false);
        console.error("Collection UUID não encontrado na URL.");
        return;
      }

      setLoading(true);
      try {
        const rawProducts = await CicaafAPI.listAllProducts();

        const mappedProducts = rawProducts.map((p: any) => ({
          product_uuid: p.uuid,
          product_type: p.type,
          product_name: p.name
        }));
        setAvailableProducts(mappedProducts);

        const existingDataResponse = await CicaafAPI.getProductionProcessed(collectionUuid);
        const existingData: IProductionData = existingDataResponse.dados;

        if (existingData && existingData.products) {
          const formattedData = existingData.products.map(apiProd => {
            const isAnimal = apiProd.product_type.includes('ANIMAL');
            return {
              ...apiProd,
              commercialized_volume: apiProd.commercialized_volume ?? 0,
              commercialized_value: apiProd.commercialized_value ?? 0,
              has_sanitary_license: !isAnimal ? (existingData.vegetal_license?.has_sanitary_license ?? false) : false,
              measurement_unit: apiProd.measurement_unit ?? 'KG',
              vegetal_license: !isAnimal && existingData.vegetal_license?.has_sanitary_license ? {
                issuing_agency: existingData.vegetal_license.issuing_agency ?? '',
                license_number: existingData.vegetal_license.license_number ?? '',
                issue_date: existingData.vegetal_license.issue_date ?? '',
              } : undefined,
              has_inspection_register: isAnimal ? (existingData.animal_inspection?.has_inspection_register ?? false) : false,
              showSeloForm: false,
              inspection_seals: isAnimal ? (existingData.animal_inspection?.inspection_seals ?? []) : [],

            };
          });
          setFormData(formattedData);
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, [collectionUuid]);



  const handleSalvar = async () => {
    if (!collectionUuid) {
      console.error("Não é possível salvar, UUID da coleção não encontrado.");
      showAlert("Erro: UUID da coleção não encontrado.", 'error');
      return;
    }

    setSaving(true);

    try {
      const validation = validateFormData(formData);
      if (!validation.valid) {
        showAlert(validation.message || 'Validação inválida', 'error');
        setSaving(false);
        return;
      }

      const payload = buildPayload(formData);

      await CicaafAPI.updateProductionComercialization(collectionUuid, payload);

      navigate(ROUTES.INFORMAR_DIFICULDADES_CICAAF.replace(':uuid', collectionUuid));
    } catch (error) {
      showAlert('Ocorreu um erro ao salvar os dados. Tente novamente.', 'error');
      console.error('Erro ao salvar:', error);
    } finally {
      setSaving(false);
    }
  };



  const adicionarProduto = () => {
    const result = addProductToForm(formData, availableProducts, selectedProduct);
    setFormData(result.formData);
    setSelectedProduct(result.selectedProduct);
  };



  const removerProduto = (index: number) => {
    setFormData(removeProductAt(formData, index));
  };



  const atualizarLicencaVegetal = (produtoIndex: number, campo: keyof NonNullable<IProdutoForm['vegetal_license']>, valor: string) => {
    setFormData(updateLicenseVegetal(formData, produtoIndex, campo, valor));
  };

  const atualizarProduto = (index: number, campo: keyof IProdutoForm, valor: any) => {
    setFormData(updateProductField(formData, index, campo, valor));
  };


  const handleValorChange = (index: number, value: string) => {
    const numericValue = parseCurrencyInput(value);
    atualizarProduto(index, 'commercialized_value', Number(numericValue));
  };



  const adicionarSelo = (produtoIndex: number) => {
    const novos = addSealToProduct(formData, produtoIndex, { inspection_seal: novoSelo.inspection_seal, register_number: novoSelo.register_number, issue_date: novoSelo.issue_date });
    setFormData(novos);
    setNovoSelo({ inspection_seal: '', register_number: '', issue_date: '' });
  };

  const toggleSeloForm = (produtoIndex: number) => {
    setFormData(toggleSeloFormInForm(formData, produtoIndex));
  };



  const removerSelo = (produtoIndex: number, seloIndex: number) => {
    setFormData(removeSealFromProduct(formData, produtoIndex, seloIndex));
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <MenuProvider>
      <TopNavBar />
      <Header title="CICAAF - Produtos Processados" showBackButton={true} />
      <Box width='97%' display='flex' justifyContent='center' flexDirection='column' alignItems='center' margin='2rem'>
        <ContainerForm title='Produtos Processados' subtitle='Informe os dados dos produtos processados.' width='1152px'>
          <Box alignItems="center" display="flex" gap={2} mb={4}>
            <FormControl fullWidth>
              <InputLabel>Selecione o produto</InputLabel>
              <Select
                label="Selecione o produto"
                value={selectedProduct}
                onChange={(e) => setSelectedProduct(e.target.value as string)}

              >
                <MenuItem value=""><em>Selecione um produto</em></MenuItem>
                {availableProducts.map((prod) => (
                  <MenuItem key={prod.product_uuid} value={prod.product_uuid} disabled={formData.some(p => p.product_uuid === prod.product_uuid)}>
                    {prod.product_name} ({prod.product_type})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button startIcon={<AddIcon />} variant="contained" onClick={adicionarProduto} disabled={!selectedProduct}>
              Adicionar Produto
            </Button>
          </Box>

          {formData.map((produto, produtoIndex) => {
            const isAnimal = produto.product_type.includes('ANIMAL');
            const valorFormatado = formatCurrency(produto.commercialized_value);


            return (
              <Box key={produto.product_uuid} border="1px solid mb={4} p={3}  #eee" borderRadius={2}>
                <Box justifyContent="space-between" display="flex" alignItems="center" mb={2}>
                  <Typography variant="h6">{produto.product_name}</Typography>
                  <IconButton onClick={() => removerProduto(produtoIndex)}>
                    <DeleteIcon color="error" />
                  </IconButton>
                </Box>
                <Typography color="text.secondary" gutterBottom>{produto.product_type}</Typography>

                <Box mt={3}>
                  <Typography variant="subtitle1" gutterBottom>Valor comercializado no último ano *</Typography>
                  <TextField value={valorFormatado} fullWidth onChange={(e) => handleValorChange(produtoIndex, e.target.value)} />
                </Box>

                <Box mt={2}>
                  <TextField
                    value={produto.commercialized_volume ?? ''}
                    label="Volume comercializado no último ano"
                    onChange={(e) => {
                      const value = e.target.value === '' ? undefined : Number(e.target.value);
                      if (value === undefined || value >= 0) {
                        atualizarProduto(produtoIndex, 'commercialized_volume', value);
                      }
                    }}
                    onInput={(e: any) => {
                      const target = e.target || e.currentTarget;
                      if (!target || typeof target.value !== 'string') return;
                      // Remove non-numeric characters except decimal point
                      target.value = target.value.replace(/[^\d.]/g, '');
                      // Prevent multiple decimal points
                      const decimalCount = (target.value.match(/\./g) || []).length;
                      if (decimalCount > 1) {
                        target.value = target.value.replace(/\.(?=.*\.)/g, '');
                      }
                    }}
                    fullWidth
                    inputProps={{ inputMode: 'decimal' }}
                    sx={{
                      '& input[type=number]::-webkit-outer-spin-button,& input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                      '& input[type=number]': {
                        MozAppearance: 'textfield',
                      },
                    }}
                  />

                </Box>

                <Box mt={2}>
                  <TextField value={produto.measurement_unit} select onChange={(e) => atualizarProduto(produtoIndex, 'measurement_unit', e.target.value)} fullWidth>
                    {UNIDADES_MEDIDA.map((unidade) => (
                      <MenuItem key={unidade.value} value={unidade.value}>
                        {unidade.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>

                <Divider sx={{ my: 3 }} />

                {isAnimal ? (
                  <>
                    <Typography variant="h6" gutterBottom>Informações Sanitárias - Produto Animal</Typography>
                    <Box mb={2}>
                      <Typography variant="subtitle1" gutterBottom>Possui registro de inspeção? *</Typography>
                      <RadioGroup row value={produto.has_inspection_register ? 'sim' : 'nao'} onChange={(e) => atualizarProduto(produtoIndex, 'has_inspection_register', e.target.value === 'sim')}>
                        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                        <FormControlLabel value="nao" control={<Radio />} label="Não" />
                      </RadioGroup>
                    </Box>
                    {produto.has_inspection_register && (
                      <Box mt={3}>
                        <Typography variant="subtitle1" gutterBottom>Selos de inspeção *</Typography>
                        {produto.inspection_seals.map((selo, seloIndex) => (
                          <Box key={seloIndex} mb={3} p={2} bgcolor="#f5f5f5" borderRadius={1}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                              <Typography variant="subtitle2">Selo {seloIndex + 1}</Typography>
                              <IconButton size="small" onClick={() => removerSelo(produtoIndex, seloIndex)}><DeleteIcon fontSize="small" /></IconButton>
                            </Box>
                            <Stack spacing={2}>
                              <TextField label="Tipo de selo *" value={selo.inspection_seal} InputProps={{ readOnly: true }} fullWidth />
                              <TextField label="Número de registro *" value={selo.register_number} InputProps={{ readOnly: true }} fullWidth />
                              <TextField label="Data de emissão *" value={selo.issue_date} InputProps={{ readOnly: true }} fullWidth />
                            </Stack>
                          </Box>
                        ))}
                        {!produto.showSeloForm && (
                          <Button variant="outlined" startIcon={<AddIcon />} sx={{ mt: 2 }} onClick={() => toggleSeloForm(produtoIndex)} >Adicionar Selo</Button>
                        )}
                        {produto.showSeloForm && (
                          <Box mt={2} p={2} border="1px dashed #ccc" borderRadius={1}>
                            <Typography variant="subtitle2" gutterBottom>Adicionar Selo</Typography>
                            <Stack spacing={2}>
                              <TextField label="Tipo de selo *" select value={novoSelo.inspection_seal} onChange={(e) => setNovoSelo({ ...novoSelo, inspection_seal: e.target.value })} fullWidth>
                                {TIPOS_SELO.map((tipo) => (<MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>))}
                              </TextField>
                              <TextField placeholder="Ex: 12345/2024" label="Número de registro *" value={novoSelo.register_number} onChange={(e) => setNovoSelo({ ...novoSelo, register_number: e.target.value })} fullWidth />
                              <TextFieldDataCustom
                                type="date"
                                label="Data de emissão *"
                                InputLabelProps={{ shrink: true }}
                                value={novoSelo.issue_date}
                                onChange={(e) => setNovoSelo({ ...novoSelo, issue_date: e.target.value })}
                                fullWidth
                              />
                              <Box justifyContent="flex-end" display="flex" gap={1}>
                                <Button variant="outlined" onClick={() => toggleSeloForm(produtoIndex)}>Cancelar</Button>
                                <Button variant="contained" onClick={() => adicionarSelo(produtoIndex)} disabled={!novoSelo.inspection_seal || !novoSelo.register_number || !novoSelo.issue_date}>Adicionar</Button>
                              </Box>
                            </Stack>
                          </Box>
                        )}
                      </Box>
                    )}
                  </>
                ) : (
                  <>
                    <Typography variant="h6" gutterBottom>Informações Sanitárias - Produto Vegetal</Typography>
                    <Box mb={2}>
                      <Typography variant="subtitle1" gutterBottom>Possui alvará sanitário? *</Typography>
                      <RadioGroup row value={produto.has_sanitary_license ? 'sim' : 'nao'} onChange={(e) => atualizarProduto(produtoIndex, 'has_sanitary_license', e.target.value === 'sim')}>
                        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                        <FormControlLabel value="nao" control={<Radio />} label="Não" />
                      </RadioGroup>
                    </Box>
                    {produto.has_sanitary_license && (
                      <Stack spacing={2}>
                        <TextField label="Número de registro do alvará sanitário *" fullWidth value={produto.vegetal_license?.license_number ?? ''} onChange={(e) => atualizarLicencaVegetal(produtoIndex, 'license_number', e.target.value)} />
                        <TextField
                          label="Órgão emissor *"
                          select
                          value={produto.vegetal_license?.issuing_agency ?? ''}
                          onChange={(e) =>
                            atualizarLicencaVegetal(produtoIndex, 'issuing_agency', e.target.value)
                          }
                          fullWidth
                        >
                          {ORGAOS_EMISSORES.map((orgao) => (
                            <MenuItem key={orgao.value} value={orgao.value}>
                              {orgao.label}
                            </MenuItem>
                          ))}
                        </TextField>

                        <TextFieldDataCustom
                          label="Data de emissão *"
                          InputLabelProps={{ shrink: true }}
                          type="date"
                          value={produto.vegetal_license?.issue_date ?? ''}
                          onChange={(e) => atualizarLicencaVegetal(produtoIndex, 'issue_date', e.target.value)}
                          fullWidth
                        />
                      </Stack>
                    )}
                  </>
                )}
              </Box>
            );
          })}

          <Box justifyContent="center" display="flex" mt={4} gap={3} >
            <Button variant="outlined" onClick={() => window.history.back()} sx={{ minWidth: 120 }}>Voltar</Button>
            <Button variant="contained" color="primary" onClick={handleSalvar} disabled={formData.length === 0 || saving} startIcon={saving ? <CircularProgress size={20} /> : <SaveIcon />} sx={{ minWidth: 180 }}>
              {saving ? 'Salvando...' : 'Salvar Dados'}
            </Button>
          </Box>
        </ContainerForm>
      </Box>
      <Snackbar
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        autoHideDuration={3000}
        anchorOrigin={{ horizontal: 'center', vertical: 'top', }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          sx={{ width: '100%' }}
          severity={alertSeverity}

          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>

    </MenuProvider>
  );
};
